export const HAS_ADVOCATES_STATE = {
	none: 'None',
	one: 'One',
	multiple: 'Multiple',
};
